/* eslint-disable */
import Quill from 'quill';

const Embed = Quill.import('blots/embed');

class PlaceholderVariable extends Embed {
    static create(value) {
        const node = super.create();
        node.setAttribute('data-variable', value);
        node.setAttribute('contenteditable', 'false');
        node.textContent = '{{ ' + value + ' }}';
        return node;
    }

    static value(node) {
        return node.getAttribute('data-variable');
    }

    static formats(node) {
        return node.getAttribute('data-variable');
    }

    length() {
        return 1;
    }
}

PlaceholderVariable.blotName = 'placeholder';
PlaceholderVariable.tagName = 'SPAN';
// PERSISTED, so it does NOT get renamed with the rest of the module: this class
// is written into every stored signature and preset body, and is matched by
// WhatsAppTemplateManager (pill -> Meta {{1}}) and ConversationThread (unwrap
// before sending). Changing it would need a data migration over every stored
// body plus a blot that accepts both spellings, for a cosmetic gain.
PlaceholderVariable.className = 'ql-twig';

export default PlaceholderVariable;
